// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import withSearchBarLoadTime from '../Timing/withSearchBarLoadTime';
import {media} from '../../utils/breakpoints';
import type {Breakpoint} from '../../utils/breakpoints';
import ExpandedSearchBar from '../ExpandedSearchBar/ExpandedSearchBar';
import MobileSearchMegabox from '../MobileSearchMegabox/MobileSearchMegabox';
import type {State as ReduxState} from '../../reducers/index';
import './SearchBar.less';

type StateProps = {
    breakpoint: Breakpoint
};

export type Props = StateProps;

export const SearchBar = ({breakpoint}: Props) => {
    return (
        <div className="SearchBar">
            {!media(breakpoint, {
                minWidth: 'SM_MIN'
            }) ? (
                <div className="SearchBar__mobileMegabox visible-xs-block">
                    <MobileSearchMegabox />
                </div>
            ) : (
                <div className="SearchBar__expanded SearchBar__paddedChild hidden-xs">
                    <ExpandedSearchBar />
                </div>
            )}
        </div>
    );
};

const mapStateToProps = ({viewport}: ReduxState): StateProps => ({
    breakpoint: viewport.breakpoint
});

export default compose(
    connect(mapStateToProps),
    withSearchBarLoadTime
)(SearchBar);
